// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"NewExpenseCard_dropzone__hiH0F","loader":"NewExpenseCard_loader__2LpZw","load3":"NewExpenseCard_load3__3vxDv"};